/* eslint-disable */
import React from "react";

const BankSection = () => {
    return("BankSection");
}

export default BankSection;